/**
 * 作品詳細（dreampiece.jp contents/detail 準拠）
 */
(function () {
  function initDescToggle(root) {
    const desc = root.querySelector('[data-dreampiece-detail-desc]');
    const inner = root.querySelector('[data-dreampiece-detail-desc-inner]');
    const toggle = root.querySelector('[data-dreampiece-detail-desc-toggle]');

    if (!desc || !inner || !toggle) {
      return;
    }

    const lineClamp = window.matchMedia('(max-width: 640px)').matches ? 14 : 8;

    function refresh() {
      inner.classList.remove('is-expanded');
      inner.style.webkitLineClamp = String(lineClamp);
      inner.style.display = '-webkit-box';

      window.requestAnimationFrame(function () {
        const needsToggle = inner.scrollHeight > inner.clientHeight + 2;
        desc.classList.toggle('is-expandable', needsToggle);
        toggle.hidden = !needsToggle;
      });
    }

    toggle.addEventListener('click', function () {
      const expanded = inner.classList.toggle('is-expanded');
      if (expanded) {
        inner.style.display = 'block';
        inner.style.webkitLineClamp = 'unset';
        toggle.textContent = toggle.dataset.labelLess || '閉じる';
      } else {
        inner.style.display = '-webkit-box';
        inner.style.webkitLineClamp = String(lineClamp);
        toggle.textContent = toggle.dataset.labelMore || 'もっと見る';
      }
    });

    refresh();
    window.addEventListener('resize', refresh);
  }

  function copyText(text, button, copiedLabel) {
    if (!text) {
      return;
    }

    function onSuccess() {
      if (!button) {
        return;
      }
      const original = button.textContent;
      button.textContent = copiedLabel || 'コピーしました';
      window.setTimeout(function () {
        button.textContent = original;
      }, 2000);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(onSuccess).catch(function () {
        window.prompt('URL', text);
      });
      return;
    }

    window.prompt('URL', text);
  }

  function initCopyButtons(root) {
    root.querySelectorAll('[data-dreampiece-copy-url]').forEach(function (button) {
      button.addEventListener('click', function () {
        copyText(
          button.dataset.dreampieceCopyUrl || window.location.href,
          button,
          button.dataset.copiedLabel
        );
      });
    });
  }

  function initShare(root) {
    root.querySelectorAll('[data-dreampiece-share-copy]').forEach(function (button) {
      button.addEventListener('click', function () {
        copyText(
          button.dataset.dreampieceShareCopy || window.location.href,
          button,
          button.dataset.shareCopied
        );
      });
    });
  }

  function initMediaLightbox(root) {
    const zoom = root.querySelector('[data-dreampiece-media-zoom]');
    const dialog = root.querySelector('[data-dreampiece-media-lightbox]');

    if (!zoom || !dialog || typeof dialog.showModal !== 'function') {
      return;
    }

    const close = dialog.querySelector('[data-dreampiece-media-close]');

    zoom.addEventListener('click', function () {
      dialog.showModal();
    });

    if (close) {
      close.addEventListener('click', function () {
        dialog.close();
      });
    }

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        dialog.close();
      }
    });
  }

  function initProductDetail(root) {
    if (!root || root.dataset.dreampieceProductBound === '1') {
      return;
    }

    root.dataset.dreampieceProductBound = '1';
    initDescToggle(root);
    initCopyButtons(root);
    initShare(root);
    initMediaLightbox(root);
  }

  function boot() {
    document.querySelectorAll('[data-dreampiece-product]').forEach(initProductDetail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector('[data-dreampiece-product]');
    if (root) {
      initProductDetail(root);
    }
  });
})();
